<tam-dialog [opened]="opened" [dialogWidth]="696" class="container">
    <ng-template #title>
        <div class="dialog-title">
            {{dialogTitle}}
        </div>
        <smart-icon class="dark dialog-close" name="close" (click)="cancel()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="body-container">
            <div class="tab-box" *ngIf="currentUser.credential.publishPubConfiguration">
                <tabs [options]="tabsOptions" [underlineStyle]="true"></tabs>
            </div>
            <div *ngIf="currentTab===0" class="details-container">
                <div class="section tam-input-tip">
                    <div class="item-title">Digest Name <span class="required-field">*</span></div>
                    <div class="input tam-form-field">
                        <input type="text" [ngClass]="{'tam-input-bad':nameInvalid}" class="tam-input"
                            [(ngModel)]="emailDigest.name" (ngModelChange)="validateName($event)" />
                        <div class="tam-form-help" *ngIf="formErrorMsg.nameRequired">
                            {{'general.required_error_message' | stringLiterals}}: Digest Name.
                        </div>
                        <div class="tam-form-help" *ngIf="formErrorMsg.nameMaxLength">
                            {{'general.name_exceed_maximum' | stringLiterals: '128'}}
                        </div>
                        <div class="tam-form-help" *ngIf="formErrorMsg.nameDuplicated">
                            {{'general.name_already_exist' | stringLiterals}}
                        </div>
                    </div>
                </div>
                <div class="section tam-input-tip">
                    <div class="item-title">Description</div>
                    <div class="input tam-form-field">
                        <textarea
                            [ngClass]="{'tam-input-bad':emailDigest.description&&emailDigest.description.length>128}"
                            [(ngModel)]="emailDigest.description"
                            (ngModelChange)="validateDescription($event)"></textarea>
                        <div class="tam-form-help" *ngIf="formErrorMsg.descriptionMaxLenght">
                            Description exceeds the maximum of 128 characters allowed.
                        </div>
                    </div>
                </div>
                <div class="section" *ngIf="isDashboardType">
                    <div class="item-title">
                        Dashboard
                        <span class="required-field">*</span>
                    </div>
                    <div class="dashboard-select tam-form-field"
                        [class.error-dashboard-name]="formErrorMsg.dashboardRequired">
                        <kendo-dropdownlist [data]="dashboardItems" textField="name" valueField="id"
                            [disabled]="!needGetInfoFromServer" [(ngModel)]="selectedDashboardItem"
                            (valueChange)="changeDashboard()">
                        </kendo-dropdownlist>
                        <div class="tam-form-help" *ngIf="formErrorMsg.dashboardRequired">
                            {{'general.required_error_message' | stringLiterals}}: Dashboard.
                        </div>
                    </div>
                </div>
                <div class="section" *ngIf="isDashboardType && showFocus">
                    <div class="item-title">
                        Focus<span class="required-field">*</span>
                    </div>
                    <div class="focus-select tam-form-field" [class.error-focus]="formErrorMsg.focusRequired">
                        <kendo-multiselect #finder textField="shortName" valueField="id" [data]="focusFinderData"
                            [filterable]="true" [autoClose]="false" (filterChange)="handleFocusFilter($event)"
                            [(ngModel)]="focusSelectedItems" (valueChange)="focusValueChange()"
                            (open)="onFocusOpen($event)" (keydown.esc)="onFocusEnter($event)">
                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                            </ng-template>
                        </kendo-multiselect>
                        <div class="tam-form-help" *ngIf="formErrorMsg.focusRequired">
                            {{'general.required_error_message' | stringLiterals}}: Focus.
                        </div>
                    </div>
                </div>
                <div class="section" *ngIf="isDashboardType">
                    <div class="input tam-form-field">
                        <label class="pdf-check item-sub-title" tam-checkbox
                            [(ngModel)]="emailDigest.reportData.attachment.pdf"
                            (ngModelChange)="validateExportOptions($event)">
                            Attach dashboard report as PDF format
                        </label>
                        <label class="xls-check item-sub-title" tam-checkbox [disabled]="!isGridWidgetIncluded"
                            [(ngModel)]="emailDigest.reportData.attachment.excel"
                            (ngModelChange)="validateExportOptions($event)">
                            Attach grid data as Excel format
                        </label>
                        <div class="tam-form-help" *ngIf="formErrorMsg.noExportOptionChecked">
                            Please select at least one option.
                        </div>
                    </div>
                </div>
                <div class="section" *ngIf="isDashboardType">
                    <div class="print-properties">
                        <div class="page-size">
                            <div class="item-title">
                                Page Size
                            </div>
                            <div class="focus-select">
                                <kendo-dropdownlist [data]="pageSizeItems"
                                    [disabled]="!emailDigest.reportData.attachment.pdf"
                                    [(ngModel)]="emailDigest.reportData.displaySetting['pageSize']">
                                </kendo-dropdownlist>
                            </div>
                        </div>
                        <div class="layout">
                            <div class="item-title">
                                Layout
                            </div>
                            <div class="focus-select">
                                <kendo-dropdownlist [data]="layoutItems"
                                    [disabled]="!emailDigest.reportData.attachment.pdf"
                                    [(ngModel)]="emailDigest.reportData.displaySetting['layout']">
                                </kendo-dropdownlist>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="item-title">Frequency</div>
                    <div class="row item-sub-title">Receive Frequency:</div>
                    <div class="row control">
                        <div class="frequency">
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                                [data]="frequencyList" [textField]="'value'" [valueField]="'id'"
                                [value]="selectedFrequency" (valueChange)="onChangeFrequency($event)">
                            </kendo-dropdownlist>
                        </div>
                        <div class="wrapper" *ngIf="selectedFrequency.id!=='daily'">
                            <div class="sub-control">On:</div>
                            <div class="on sub-control" *ngIf="selectedFrequency.id==='weekly'">
                                <kendo-buttongroup [selection]="onWeeklyMode">
                                    <button *ngFor="let item of onWeeklyList;index as i" kendoButton [toggleable]="true"
                                        [selected]="item.selected"
                                        (selectedChange)="onChangeOnWeekly($event,i)">{{item.value}}</button>
                                </kendo-buttongroup>
                            </div>
                            <div class="on sub-control" *ngIf="selectedFrequency.id==='monthly'">
                                <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                    [ngStyle]="{'width':(selectedOnMonthly1.id==='day:L'?'100%':'')}"
                                    [filterable]="false" [data]="onMonthlyList1" [textField]="'value'"
                                    [valueField]="'id'" [value]="selectedOnMonthly1"
                                    (valueChange)="onChangeOnMonthly1($event)"></kendo-dropdownlist>
                                <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" class="sub-control"
                                    *ngIf="selectedOnMonthly1.id!=='day:L'" [filterable]="false" [data]="onMonthlyList2"
                                    [textField]="'value'" [valueField]="'id'" [value]="selectedOnMonthly2"
                                    (valueChange)="onChangeOnMonthly2($event)"></kendo-dropdownlist>
                            </div>
                            <div class="sub-control">Every:</div>
                            <div class="every sub-control">
                                <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                                    [data]="everyList" [textField]="'value'" [valueField]="'id'" [value]="selectedEvery"
                                    (valueChange)="onChangeEvery($event)">
                                </kendo-dropdownlist>
                            </div>
                            <div class="sub-control">{{frequencyUnit}}</div>
                            <div class="sub-control" kendoTooltip
                                [title]="'Some months have fewer than '+selectedOnMonthly2.id+' days, For these months, Digest Email will not be sent, please use last day option.'"
                                *ngIf="emailDigest&&emailDigest.scheduler&&(emailDigest.scheduler.on==='day:29'||emailDigest.scheduler.on==='day:30'||emailDigest.scheduler.on==='day:31')">
                                <smart-icon name="info-o"></smart-icon>
                            </div>
                        </div>
                    </div>
                    <div class="row item-sub-title">Time:</div>
                    <div class="row control time">
                        <kendo-timepicker [steps]="timesteps" [format]="'hh:mm a'" [value]="time"
                            (valueChange)="onChangeTime($event)"></kendo-timepicker>
                    </div>
                    <div class="row item-sub-title">Start Date:</div>
                    <div class="row control">
                        <kendo-datepicker calendarType="classic" [value]="startDate"
                            (valueChange)="onChangeStartDate($event)">
                        </kendo-datepicker>
                    </div>
                    <div class="row item-sub-title">Timezone:</div>
                    <div class="row control time-zone">
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                            [data]="timezoneList" [textField]="'name'" [valueField]="'id'" [value]="selectedTimezone"
                            (valueChange)="onChangeTimezone($event)">
                        </kendo-dropdownlist>
                    </div>
                </div>
                <div class="section" *ngIf="!isDashboardType">
                    <div class="item-title">Other settings</div>
                    <label class="other item-sub-title" tam-checkbox [(ngModel)]="emailDigest.hideBlankEmail">
                        Check to avoid sending blank emails.
                    </label>
                    <label class="other item-sub-title" tam-checkbox [(ngModel)]="emailDigest.hideBlankSection">
                        Check to hide empty section(s) in digest email.
                    </label>
                </div>
            </div>
            <div *ngIf="currentTab===1" class="recipients-container">
                <div class="dual-list-box">
                    <tam-dual-list #dualList [config]="dualListConfig" [itemRender]="listItem">
                        <ng-template #listItem let-item>
                            <div class="list-item">
                                <span
                                    [style.font-weight]="item.data.type === 'team' ? 'bold' : 'normal'">{{item.data.name}}</span>
                            </div>
                        </ng-template>
                    </tam-dual-list>
                </div>
                <label>By default, primary email address will be used for digest email.</label>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">
            <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" (click)="cancel()">Cancel</button>
            <button tam-button [tamType]="'primary'" [tamSize]="'normal'" [tamLoading]="isProgressing"
                [disabled]="isProgressing" (click)="save()">Save</button>
        </div>
    </ng-template>
</tam-dialog>